export default class UserSceneTapsBatch {
  constructor(public jobId: string) {}
}
